import { lazy } from 'react';

const SendIntegrativeTransformerTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/integrative/consult/send-transfer-info',
			component: lazy(() => import('./SendTransferContainer'))
		}
	]
};

export default SendIntegrativeTransformerTransferConfig;


